import { useQuery } from '@tanstack/react-query';
import type { AccountStatus } from '../../auth/account-status';
export const ACCOUNT_STATUS_QUERY_KEY = ['account-status'] as const;

export function useAccountStatus(poll = false) {
  return useQuery<AccountStatus>({
    queryKey: ACCOUNT_STATUS_QUERY_KEY,
    queryFn: async ({ signal }) => {
      const response = await fetch('/auth/account-status', { credentials: 'include', cache: 'no-store', signal });
      if (!response.ok) throw new Error(response.status === 401 ? 'Sign in to check account access.' : 'Account access could not be verified.');
      const result = await response.json();
      const countOrUnknown = (value: unknown) => value === null || (typeof value === "number" && Number.isFinite(value) && value >= 0);
      if (!result || typeof result.plan_label !== 'string' || typeof result.entitled !== 'boolean'
        || !['paid', 'personal'].includes(result.access_policy) || !Array.isArray(result.effective_scopes)
        || !result.effective_scopes.every((scope: unknown) => typeof scope === 'string') || !result.quota
        || !countOrUnknown(result.quota.used) || !countOrUnknown(result.quota.limit) || !countOrUnknown(result.quota.remaining)
        || ![null, 'month', 'year'].includes(result.quota.period)
        || !(result.quota.resets_at === null || (typeof result.quota.resets_at === 'string' && Number.isFinite(Date.parse(result.quota.resets_at))))) {
        throw new Error('Account access could not be verified.');
      }
      return result as AccountStatus;
    },
    staleTime: 30_000,
    refetchInterval: poll ? 60_000 : false,
    refetchOnWindowFocus: true,
    retry: 1,
  });
}
